/*
 * Copyright (c) Nexign, JSC, 2024.
 */
/**
 *
 * @author Ilya Baranchikov
 * @version 1.30.0
 * @since 1.30.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '@/main/reducers/rootReducer';

import { TWizardCollationReportSetParamsPayload } from './types/wizardCollationReportActionTypes';
import { initialWizardCollationReportState, IWizardCollationReportReducer } from './wizardCollationReportReducer';

export const makeSelectWizardCollationReportState = (state: IRootReducer): IWizardCollationReportReducer =>
    state.wizardCollationReport || initialWizardCollationReportState;

export const makeSelectWizardCollationReportParam = (
    key: keyof TWizardCollationReportSetParamsPayload,
): OutputSelector<IRootReducer, any, (state: IWizardCollationReportReducer) => any> =>
    createSelector(makeSelectWizardCollationReportState, (state) => state[key]);

export const makeSelectWizardCollationReportIsStepValid = (): OutputSelector<
    IRootReducer,
    boolean,
    (state: IWizardCollationReportReducer) => boolean
> => createSelector(makeSelectWizardCollationReportState, (state) => state.isStepValid);

export const makeSelectWizardCollationReportParams = (): OutputSelector<
    IRootReducer,
    IWizardCollationReportReducer,
    (state: IWizardCollationReportReducer) => IWizardCollationReportReducer
> => createSelector(makeSelectWizardCollationReportState, (state) => state);
